import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { CategoryCarouselItem } from '@promo/const';
import { PromoService } from '@promo/data-access';
import { SdvorSwiperComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { combineLatest, filter, map, Observable } from 'rxjs';
import { Swiper, SwiperOptions } from 'swiper/types';

@Component({
  selector: 'sd-category-carousel',
  imports: [AsyncPipe, RouterLink, NgOptimizedImage, SdvorSwiperComponent, NgbCarouselModule],
  templateUrl: './category-carousel.component.html',
  styleUrls: ['./category-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryCarouselComponent implements OnInit {
  protected isTabletMdUp$: Observable<boolean> = this.deviceService.isTabletMdUp$;
  protected isDesktop$: Observable<boolean> = this.deviceService.isDesktopLgUp$;
  protected isLoading$: Observable<boolean> = this.promoService.getPromoLoading();
  protected numberOfSkeletons$ = combineLatest({ isTabletMdUp: this.isTabletMdUp$, isDesktop: this.isDesktop$ }).pipe(
    map(({ isTabletMdUp, isDesktop }) => (isDesktop ? 8 : isTabletMdUp ? 4 : 3)),
  );

  protected categoryCarousel$: Observable<CategoryCarouselItem[]>;

  protected isAtEnd = signal(false);

  protected config: SwiperOptions = {
    slidesPerView: 'auto',
    navigation: { enabled: false },
    scrollbar: { enabled: false },
  };

  constructor(
    private deviceService: DeviceService,
    private promoService: PromoService,
  ) {}

  ngOnInit(): void {
    this.categoryCarousel$ = combineLatest({
      promo: this.promoService.getPromo().pipe(filter((promo) => !!promo)),
      isTabletMdUp: this.isTabletMdUp$,
      isDesktop: this.isDesktop$,
    }).pipe(
      map(({ promo, isTabletMdUp, isDesktop }) => {
        if (promo.categoryCarousel?.length) {
          return promo.categoryCarousel.map((category) => {
            const { url } = category;

            return {
              ...category,
              url: isDesktop ? url.isDesktop : isTabletMdUp ? url.isTablet : url.isMobile,
            };
          });
        }

        return [];
      }),
    );
  }

  onReachEnd(): void {
    this.isAtEnd.set(true);
  }

  onFromEdge(swiper: Swiper): void {
    this.isAtEnd.set(swiper.isEnd);
  }
}
